class CustomOffers {
    constructor(dbID, couponCode, date, dateTime, discount, image, offerDescription, offerTitle, phoneNo, status, time, type, dining, hotel, offerType, online, orderPickup, visibility, maximumDiscountValue, minimumOrderValue, priority , isFirstOrder , mainStoreId,) {
      this.dbID = dbID;
      this.couponCode = couponCode;
      this.date = date;
      this.dateTime = dateTime;
      this.discount = discount;
      this.image = image;
      this.offerDescription = offerDescription;
      this.offerTitle = offerTitle;
      this.phoneNo = phoneNo;
      this.status = status;
      this.time = time;
      this.type = type;
      this.dining = dining;
      this.hotel = hotel;
      this.offerType = offerType;
      this.online = online;
      this.orderPickup = orderPickup;
      this.visibility = visibility;
      this.maximumDiscountValue = maximumDiscountValue;
      this.minimumOrderValue = minimumOrderValue;
      this.priority = priority;
      this.isFirstOrder = isFirstOrder;
      this.mainStoreId = mainStoreId ?? "";
    }
  
    static fromJson(key, json) {
      const statusValues = {
        "Active": "ACTIVE",
        "DeActive": "DE_ACTIVE"
      };
  
      const diningValues = {
        null: "NO",
        "": "NO",
        "No": "NO",
        "Yes": "YES"
      };
  
      const visibilityValues = {
        null: "EMPTY",
        "No": "NO",
        "": "EMPTY",
        "Yes": "YES"
      };
  
      const status = statusValues[json["status"]] || "DE_ACTIVE";
      const dining = diningValues[json["dining"]] || "NO";
      const hotel = diningValues[json["hotel"]] || "NO";
      const online = diningValues[json["online"]] || "NO";
      const orderPickup = diningValues[json["orderPickup"]] || "NO";
      const visibility = visibilityValues[json["visibility"]] || "NO";
      const isFirstOrder = diningValues[ json["isFirstOrder"] ] || "NO";
  
      const customOffers = new CustomOffers(
          key,
          json["couponCode"],
          json["date"],
          json["dateTime"],
          json["discount"],
          json["image"],
          json["offerDescription"],
          json["offerTitle"],
          json["phoneNo"],
          status,
          json["time"],
          json["type"],
          dining,
          hotel,
          json["offerType"],
          online,
          orderPickup,
          visibility,
          json["maximumDiscountValue"],
          json["minimumOrderValue"],
          json["priority"],
          isFirstOrder,
          json["mainStoreId"]

      );
  
      return customOffers;
    }
  }

  
export default CustomOffers;



